export const GET_FILE = 'GET_FILE'
export const GET_WATERMARKED_FILE = 'GET_WATERMARKED_FILE'
export const CANCEL_ALL_WATERMARKED_REQUEST_PENDING = 'CANCEL_ALL_WATERMARKED_REQUEST_PENDING'
